import CirclesComponent from '../../components/Circles/CirclesComponent';

const CirclesPage = () => <CirclesComponent />;

export default CirclesPage;
